import { API } from '../../Services/Api';

const request = new API();

export const getPlans = () => request.api.get(`/subscription/plan/`);
export const getPlan = (id) => request.api.get(`/subscription/plan/${id}/`);
export const getCountries = () => request.api.get(`/user/country-list/`);
export const checkDiscountCode = (code) => request.api.get(`/discount/check`, { code });
export const saveSubscription = (data) => request.api.post(`/payments/subscribe`, data);
export const updateSubscription = (data) => request.api.post(`/payments/subscription/change`, {...data, plan: data?.plan?.id});
export const deleteSubscription = () => request.api.delete(`/payments/subscription/change`);
export const undoDeleteSubscription = ({oldSchedule }) => request.api.post(`/payments/subscription/change`, {plan: oldSchedule, force: false});
